var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-max mt-5" }, [
    _c("div", { staticClass: "row mb-5" }, [
      _c(
        "div",
        { staticClass: "col-sm-10 offset-sm-1 col-md-6 offset-md-3" },
        [
          _c(
            "div",
            [
              _c("h1", { staticClass: "login-view-title mb-5" }, [
                _vm._v(_vm._s(_vm.$translate("Ceres::Template.login"))),
              ]),
              _vm._v(" "),
              _c("login", {
                attrs: {
                  backlink: _vm.sanitizedBacklink,
                  "has-to-forward": true,
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "extend-overlay-buttons",
                      fn: function () {
                        return [_vm._t("extend-overlay-buttons")]
                      },
                      proxy: true,
                    },
                  ],
                  null,
                  true
                ),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("hr"),
          _vm._v(" "),
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                staticClass:
                  "col-sm-{% if 'my-account' not in backlink %}6{% else %}12{% endif %}",
                class: {
                  "col-sm-6": !_vm.myAccountInBacklink,
                  "col-sm-12": _vm.myAccountInBacklink,
                },
              },
              [
                _c(
                  "a",
                  {
                    staticClass: "btn btn-primary btn-block mb-3",
                    attrs: { href: _vm.registrationUrl },
                  },
                  [
                    _c("i", {
                      staticClass: "fa fa-user-plus",
                      attrs: { "aria-hidden": "true" },
                    }),
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.$translate("Ceres::Template.loginRegister")
                        ) +
                        "\n                    "
                    ),
                  ]
                ),
              ]
            ),
            _vm._v(" "),
            !_vm.myAccountInBacklink
              ? _c("div", { staticClass: "col-sm-6" }, [
                  _c(
                    "button",
                    {
                      staticClass: "btn btn-primary btn-block mb-3",
                      on: {
                        click: function ($event) {
                          return _vm.openGuestModal()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa fa-shopping-bag",
                        attrs: { "aria-hidden": "true" },
                      }),
                      _vm._v(
                        "\n                        " +
                          _vm._s(
                            _vm.$translate("Ceres::Template.loginOrderAsGuest")
                          ) +
                          "\n                    "
                      ),
                    ]
                  ),
                ])
              : _vm._e(),
          ]),
          _vm._v(" "),
          _vm._t("additional-content-after-buttons"),
        ],
        2
      ),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        ref: "guestModal",
        staticClass: "modal fade",
        attrs: { tabindex: "-1", role: "dialog" },
      },
      [
        _c("div", { staticClass: "modal-dialog" }, [
          _c("div", { staticClass: "modal-content" }, [
            _c("div", { staticClass: "modal-header" }, [
              _c("div", { staticClass: "modal-title h3" }, [
                _vm._v(
                  _vm._s(_vm.$translate("Ceres::Template.loginOrderAsGuest"))
                ),
              ]),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "close",
                  attrs: {
                    type: "button",
                    "data-testing": "guest-login-modal",
                    "data-dismiss": "modal",
                    "aria-hidden": "true",
                    "aria-label": _vm.$translate("Ceres::Template.closeIcon"),
                  },
                },
                [_vm._v("×")]
              ),
            ]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "modal-body" },
              [
                _c("guest-login", {
                  attrs: {
                    backlink: _vm.sanitizedBacklink,
                    "initial-email": _vm.guestEmail,
                  },
                }),
              ],
              1
            ),
          ]),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }